module.exports = "<!-- <app-header></app-header> -->\r\n <router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1